import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { Text } from 'foundations-components/components/Text';
import { REP_OVERVIEW } from '../../../constants/Events';
import { FMO_TOUR_CREATE_FORECAST_STEP } from '../../../constants/TourConstants';
import { trackCancelUITour, trackNextStepUITour } from '../../../utils/usageTracker';
import { getIsDealStageView } from '../../../selectors/forecastSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateForecastTourStep = ({
  children
}) => {
  const {
    tour
  } = useContext(TourContext);
  const isDealStageView = useSelector(getIsDealStageView);
  const handleCancelTour = useCallback(() => {
    trackCancelUITour(FMO_TOUR_CREATE_FORECAST_STEP, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const tourKey = tour.getTour();
  if (!tourKey) {
    return children;
  }
  return /*#__PURE__*/_jsx(UITourStep, {
    tourKey: tourKey,
    stepKey: FMO_TOUR_CREATE_FORECAST_STEP,
    showSteps: true,
    placement: "bottom",
    showCloseButton: true,
    onClickCloseButton: handleCancelTour,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-primary-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.existing.migrationTour.createForecastStep.title"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tour.existing.migrationTour.createForecastStep.body"
      }),
      footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
        children: /*#__PURE__*/_jsx(UITourNextButton, {
          beforeNext: () => trackNextStepUITour(FMO_TOUR_CREATE_FORECAST_STEP, REP_OVERVIEW, isDealStageView),
          use: "primary",
          size: "small"
        })
      })
    },
    children: children
  });
};
export default CreateForecastTourStep;